(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 1023px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      if (!this.searchModal) {
        this.searchModal = this.header.querySelector('details-modal');
      }
      if (this.searchModal) {
        this.searchModal.close(false);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["multicolumn-headings"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__multicolumnHeadingsPaginationV1) return;
    window.__multicolumnHeadingsPaginationV1 = true;

    function initMulticolumnPagination(root) {
      if (!root || root.getAttribute('data-pagination') !== 'true') return;
      if (root.dataset.multicolumnPaginationInit === 'true') return;
      root.dataset.multicolumnPaginationInit = 'true';

      const items = root.querySelectorAll('.multicolumn-headings__page-item');
      const prev = root.querySelector('[data-pagination-prev]');
      const next = root.querySelector('[data-pagination-next]');
      const status = root.querySelector('[data-pagination-status]');
      if (!items.length || !prev || !next || !status) return;

      const mq = window.matchMedia('(min-width: 750px)');

      let currentPage = 1;

      function pageAttr() {
        return mq.matches ? 'dPage' : 'mPage';
      }

      function totalPages() {
        let max = 0;
        const attr = pageAttr();
        items.forEach(function (el) {
          const v = parseInt(el.dataset[attr], 10) || 0;
          if (v > max) max = v;
        });
        return Math.max(1, max);
      }

      function apply() {
        const attr = pageAttr();
        const total = totalPages();
        currentPage = Math.min(Math.max(1, currentPage), total);

        items.forEach(function (el) {
          const p = parseInt(el.dataset[attr], 10) || 0;
          const show = p === currentPage;
          el.toggleAttribute('hidden', !show);
          el.setAttribute('aria-hidden', show ? 'false' : 'true');
        });

        status.textContent = currentPage + ' / ' + total;
        prev.disabled = currentPage <= 1;
        next.disabled = currentPage >= total;
      }

      function onBreakpointChange() {
        currentPage = 1;
        apply();
      }

      prev.addEventListener('click', function () {
        currentPage = Math.max(1, currentPage - 1);
        apply();
      });
      next.addEventListener('click', function () {
        currentPage = Math.min(totalPages(), currentPage + 1);
        apply();
      });

      if (typeof mq.addEventListener === 'function') {
        mq.addEventListener('change', onBreakpointChange);
      } else if (typeof mq.addListener === 'function') {
        mq.addListener(onBreakpointChange);
      }

      apply();
    }

    function scanRoots(container) {
      var scope = container || document;
      scope.querySelectorAll('.multicolumn-headings[data-pagination="true"]').forEach(initMulticolumnPagination);
    }

    document.addEventListener('DOMContentLoaded', function () {
      scanRoots();
    });

    document.addEventListener('shopify:section:load', function (event) {
      var root = event.target.querySelector('.multicolumn-headings[data-pagination="true"]');
      if (root) {
        delete root.dataset.multicolumnPaginationInit;
        initMulticolumnPagination(root);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
